/**
 * @deprecated Используйте общий компонент из reports/components/BubbleChart
 * Этот файл оставлен для обратной совместимости
 */
import BubbleChart from '../../../components/BubbleChart';

export default BubbleChart;
